import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/system-invoice'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function PreviewInvoice(invoiceId) {
  return ApiRequest.get(`${BaseRoute}/${invoiceId}/preview`)
}

function DownloadInvoice(invoiceId) {
  return ApiRequest.get(`${BaseRoute}/${invoiceId}/preview?type=pdf`, {
    responseType: 'arraybuffer',
  })
}

function SendInvoice(invoiceId) {
  return ApiRequest.post(`${BaseRoute}/${invoiceId}/sendInvoice`)
}

function MarkAsPaid(invoiceId) {
  return ApiRequest.post(`${BaseRoute}/${invoiceId}/markAsPaid`)
}

function CancelInvoice(invoiceId) {
  return ApiRequest.post(`${BaseRoute}/${invoiceId}/cancelInvoice`)
}

function CalculateSystemInvoice(data) {
  return ApiRequest.post(`${BaseRoute}/calculate`, data)
}

function BillingSetting(tenantId, usageDate) {
  return ApiRequest.get(
    `${BaseRoute}/${tenantId}/billingSetting?usageDate=${usageDate}`
  )
}

const API = {
  ...baseFunctions,
  PreviewInvoice,
  DownloadInvoice,
  SendInvoice,
  CancelInvoice,
  MarkAsPaid,
  CalculateSystemInvoice,
  BillingSetting,
}

export default API
